export default function Butterfly() {
  const pathStyle = {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    isCustomFont: 'none',
    fontFileUrl: 'none',
    fill: 'rgb(255, 255, 255)',
    opacity: 1,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="30"
      height="30"
      viewBox="0 0 50 50"
      xmlSpace="preserve"
    >
      <desc>Created with Fabric.js 3.5.0</desc>
      <defs></defs>
      <rect x="0" y="0" width="100%" height="100%" fill="none" />
      <g transform="matrix(0.0437 0 0 0.0437 24.98 24.98)" id="268909">
        <g vectorEffect="non-scaling-stroke">
          <g transform="matrix(1.5625 0 0 1.5625 -0.0039 -35.4672)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-255.9975, -233.301)"
              d="M 266.002 187.41 h -20.01 c -12.995 0 -23.523 10.535 -23.523 23.531 v 44.714 c 0 12.996 10.528 23.537 23.523 23.537 h 20.01 c 12.996 0 23.524 -10.541 23.524 -23.537 v -44.714 C 289.526 197.945 278.998 187.41 266.002 187.41 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 -0.0156 176.8805)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-255.99, -369.2035)"
              d="M 227.752 407.991 c 0 40.636 17.972 40.636 28.245 40.636 c 10.26 0 28.231 0 28.231 -40.636 c 0 -40.638 0 -118.211 0 -118.211 h -56.476 C 227.752 289.781 227.752 367.354 227.752 407.991 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 -72.1 -214.4672)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-209.856, -118.741)"
              d="M 192.466 102.655 c 3.246 0 6.277 -0.791 8.973 -2.179 c 10.689 14.893 19.286 30.961 25.536 44.265 c 3.983 8.489 7.014 15.859 9.053 21.089 c 1.019 2.622 1.784 4.708 2.294 6.122 c 0.255 0.711 0.442 1.254 0.563 1.623 c 0.067 0.18 0.121 0.315 0.148 0.402 l 0.027 0.1 l 0.013 0.034 l 7.806 -2.609 c -0.028 -0.107 -4.292 -12.868 -12.446 -30.256 c -6.465 -13.76 -15.357 -30.404 -26.609 -46.002 c 2.682 -3.359 4.292 -7.604 4.292 -12.231 c 0 -10.85 -8.798 -19.642 -19.648 -19.642 c -10.85 0 -19.635 8.792 -19.635 19.642 C 172.831 93.864 181.616 102.655 192.466 102.655 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 72.0867 -214.464)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-302.1355, -118.743)"
              d="M 272.922 174.079 c 0.228 -0.65 4.507 -13.277 12.473 -30.129 c 6.21 -13.15 14.693 -28.875 25.167 -43.473 c 2.682 1.388 5.726 2.179 8.972 2.179 c 10.836 0 19.635 -8.791 19.635 -19.641 c 0 -10.85 -8.798 -19.642 -19.635 -19.642 c -10.85 0 -19.648 8.792 -19.648 19.642 c 0 4.627 1.61 8.872 4.292 12.231 c -11.259 15.598 -20.151 32.242 -26.616 46.002 c -8.168 17.388 -12.419 30.149 -12.46 30.256 l 7.819 2.609 V 174.079 z"
              strokeLinecap="round"
            />
          </g>
          <g
            transform="matrix(1.5625 0 0 1.5625 -235.5853 -93.7944)"
            id="_x32_"
          >
            <path
              style={pathStyle}
              transform=" translate(-105.2254, -195.9716)"
              d="M 207.943 300.369 c 0.698 -0.054 1.556 -0.1 2.508 -0.141 v -84.748 l -2.508 -3.366 c 0 0 -98.79 -127.076 -149.874 -123.548 C 26.725 90.725 -17.184 151.172 6.97 222.703 C 30.816 293.308 61.73 311.649 207.943 300.369 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 -208.5471 190.175)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-122.5299, -377.712)"
              d="M 140.134 316.001 c -28.782 0 -51.675 -2.374 -70.317 -7.443 l -4.936 3.185 c -71.537 70.598 -21.512 144.523 44.272 134.143 c 55.752 -8.798 99.702 -69.419 106.005 -79.698 v -53.385 c -0.496 0.013 -5.552 0.04 -5.766 0.06 C 182.045 314.968 159.393 316.001 140.134 316.001 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 235.5858 -93.7931)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-406.7749, -195.9724)"
              d="M 453.933 88.567 c -51.098 -3.528 -149.875 123.548 -149.875 123.548 l -2.508 3.366 v 84.748 c 0.952 0.04 1.797 0.087 2.508 0.141 c 146.2 11.279 177.127 -7.061 200.973 -77.666 C 529.185 151.172 485.262 90.725 453.933 88.567 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1.5625 0 0 1.5625 208.547 190.1727)" id="_x32_">
            <path
              style={pathStyle}
              transform=" translate(-389.4701, -377.7105)"
              d="M 442.184 308.557 c -18.642 5.07 -41.536 7.443 -70.317 7.443 c -19.259 0 -41.911 -1.032 -69.257 -3.139 c -0.228 -0.02 -5.271 -0.046 -5.768 -0.06 v 53.385 c 6.29 10.28 50.254 70.901 105.992 79.698 c 65.797 10.38 115.823 -63.544 44.285 -134.143 L 442.184 308.557 z"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
